module.exports = __webpack_public_path__ + "static/media/chainx_wallet.5c2eb073.png";